import React, {RefObject} from 'react'
import {Form as FormControl, FormInstance} from 'antd';
import IForm from "../../../model/interface/form/IForm";
import FormFieldType from "../configuration/form/FormElement/formField/FormFieldType";
import FormEditor from "../configuration/form/FormEditor";
import IBaseProps from "../../../model/interface/IBaseProps";
import FormElements from "./FormElements";
import {connect, RootStateOrAny} from "react-redux";
import selectors from "../../../redux/selectors";
import IContentType from "../../../model/interface/dataStorage/IContentType";
import ReportWidgetType from "../configuration/report/widget/ReportWidgetType";
import {IActionResult} from "../../../model/service/dataStorage/ActionsService";
import IRestResource from "../../../model/interface/api/IRestResource";

interface IState {
    loading: boolean
    formIsReady: boolean
}

interface IProps extends IBaseProps {
    form: IForm,
    values: { [name: string]: any }
    onSubmit?: (values: any) => void
    onValuesChange?: (values: any) => void
    findContentTypeByUuid: (uuid: string) => IContentType
    onActionStart?: (values: any) => Promise<void>
    onActionEnd?: (result?: IActionResult) => Promise<void>
    formRef: RefObject<FormInstance>
}

class Form extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: true,
            formIsReady: false
        };
    }

    getContentType = (uuid?: string | null) => {
        const {form, findContentTypeByUuid} = this.props
        return findContentTypeByUuid(uuid || form.contentType)
    }

    onChange = (values: any) => {
        const {onValuesChange} = this.props
        this.forceUpdate(() => onValuesChange?.(values))
    }

    onActionFinish = (result?: IActionResult) => {
        const {onActionEnd, formRef} = this.props
        return onActionEnd?.(result).then(() => formRef.current?.resetFields()) || Promise.resolve()
    }

    onActionStart = () => {
        const {onActionStart, formRef} = this.props
        return onActionStart?.(formRef.current?.getFieldsValue()) || Promise.resolve(formRef.current?.getFieldsValue())
    }

    static buildInitialValues(form: IForm, values: IRestResource, contentType: IContentType, findContentTypeByUuid: (uuid: string) => IContentType) {
        const structure = FormEditor.widgetsToFormStructure(form.widgets, contentType, findContentTypeByUuid);
        let initialValues = {} as { [name: string]: any }
        Object.keys(structure).forEach((key) => {
            const fieldNode = structure[key]
            if (typeof fieldNode.field !== 'undefined' && values
                && (fieldNode.options?.initialValue || values[fieldNode.field.name])
            ) {
                const value = values[fieldNode.field.name] ?
                    values[fieldNode.field.name] : fieldNode.options?.initialValue
                initialValues[fieldNode.field.name] = FormFieldType.formatToForm(fieldNode.options.type, value)
            }
            if (structure[key].type === ReportWidgetType.COMMENT && values.hasOwnProperty('thread')) {
                initialValues['thread'] = values['thread'] ? values['thread'].id : null
            }
        })
        return initialValues
    }


    render() {
        const {values, form, onSubmit, history, match, findContentTypeByUuid, formRef} = this.props
        const initialValues = Form.buildInitialValues(form, values, this.getContentType(), findContentTypeByUuid)
        const {formIsReady} = this.state

        return (
            <div>
                <FormControl layout={"vertical"} ref={(instance) => {
                    // Assign to the prop ref
                    if (formRef) (formRef as any).current = instance;
                    // If the child needs to 'know' immediately,
                    // you could also save this to local state
                    if (!formIsReady && instance) {
                        this.setState({ formIsReady: true });
                    }
                }} name={'form_' + form.id}
                             initialValues={initialValues} onValuesChange={this.onChange} onFinish={onSubmit}>
                    {formIsReady && (
                        <FormElements onActionStart={this.onActionStart} onActionFinish={this.onActionFinish}
                                      contentType={this.getContentType()} match={match}
                                      history={history} form={form} values={values} formRef={formRef}/>
                    )}
                </FormControl>
            </div>
        );
    }
}

const mapStateToProps = (state: RootStateOrAny) => {

    return {
        findContentTypeByUuid: (uuid: string) => selectors.contentTypes.findOneBy(state, 'uuid', uuid)
    }
}

export default connect(mapStateToProps)(Form)